import styled, { css } from 'styled-components';
import { theme, palette, ifProp } from 'styled-tools';
import { BsTrash, BsPencil, BsLink45Deg, BsCopy } from 'react-icons/bs';
import { FaCheckCircle } from 'react-icons/fa';

import Card from '../Card';

const S = {};

S.Title = styled.h3`
  font-size: ${theme('fontSize.xs')};
  font-weight: ${theme('fontWeight.bold')};
  transition: ${theme('transition')};
  color: ${palette('titleCard')};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

S.IconsHover = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: ${ifProp('isVisible', '11px', '11px 0')};
  border-radius: ${theme('borderRadius.sm')};
  background-image: linear-gradient(
    to right,
    transparent,
    ${palette('bgCard')} 30%
  );
  opacity: ${ifProp('isVisible', '1', '0')};
  visibility: ${ifProp('isVisible', 'visible', 'hidden')};
  transform: ${ifProp('isVisible', 'scale(1)', 'scale(0)')};
  transition: ${theme('transition')};
  cursor: default;

  > * {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

S.Card = styled(Card)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 125px;
  margin-bottom: 16px;
  &:hover {
    border-color: ${palette('borderCardHover')};

    ${S.Title} {
      color: ${palette('titleCardHover')};
    }

    ${S.IconsHover} {
      padding: 11px;
      opacity: 1;
      visibility: visible;
      transform: scale(1);
    }
  }
`;

S.Author = styled.p`
  font-size: ${theme('fontSize.xxs')};
  color: ${palette('textContrast2')};
  margin-bottom: -5px;
`;

S.Date = styled.p`
  font-size: ${theme('fontSize.xxs')};
  color: ${palette('textContrast3')};
  margin-top: 3px;
`;

const iconStyle = css`
  width: 16px;
  height: 16px;
  color: ${palette('asphalt')};
  transition: ${theme('transition')};
  cursor: ${ifProp('disabled', 'default', 'pointer')};
`;

S.CopyIcon = styled(BsLink45Deg)`
  ${iconStyle}
  &:hover {
    color: ${palette('primary')};
  }
`;

S.CopiedIcon = styled(FaCheckCircle)`
  ${iconStyle};
  color: ${palette('green')};
`;

S.DeleteIcon = styled(BsTrash)`
  ${iconStyle}
  &:hover {
    color: ${ifProp('disabled', palette('asphalt'), palette('private'))};
  }
`;

S.DuplicateIcon = styled(BsCopy)`
  ${iconStyle}
  &:hover {
    color: ${ifProp('disabled', palette('asphalt'), palette('primary'))};
  }
`;

S.EditIcon = styled(BsPencil)`
  ${iconStyle}
  &:hover {
    color: ${ifProp('disabled', palette('asphalt'), palette('primary'))};
  }
`;

S.TooltipContent = styled.div`
  max-width: 150px;
  width: fit-content;
  line-height: 1.5;
  font-size: ${theme('fontSize.xxs')};
`;

S.AvatarGroup = styled.div`
  width: fit-content;
  margin: 5px 0 0 0;
  display: flex;
  ${ifProp(
    'group',
    css`
      gap: 0;
    `,
    css`
      gap: ${theme('spacing.sm')};
    `
  )}
`;

export default S;
